module.exports = __webpack_public_path__ + "img/blumenlady.5093ac8e.jpg";